module.exports = __webpack_public_path__ + "img/slide10.b95486f0.png";